/* GG_STICKY_BUY_120 */
(() => {
  'use strict';
  if (window.ggStickyBuy120) return;
  window.ggStickyBuy120 = true;
  const bars = new Map();
  const overlays = 'cart-drawer.active,dialog[open],header-drawer details[open],details-modal details[open],.gg-video-modal.is-open';
  let frame = 0;
  function update() {
    frame = 0;
    const covered = Boolean(document.querySelector(overlays) || document.fullscreenElement);
    for (const [bar, entry] of bars) {
      if (!bar.isConnected || !entry.main.isConnected) {
        entry.resize?.disconnect();
        bars.delete(bar);
        continue;
      }
      const rect = entry.main.getBoundingClientRect();
      const show = rect.width > 0 && rect.height > 0 && rect.bottom <= 0 && !covered;
      if (entry.visible !== show) {
        entry.visible = show;
        bar.classList.toggle('gg120-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.inert = !show;
        entry.submit.tabIndex = show ? 0 : -1;
      }
      // Keep the existing form, variant selection and Shopify submit handling.
      if (entry.submit.disabled !== entry.main.disabled) entry.submit.disabled = entry.main.disabled;
      const height = Math.ceil(bar.getBoundingClientRect().height);
      if (entry.spacer && height > 0 && entry.spacer.style.height !== height + 'px') {
        entry.spacer.style.height = height + 'px';
      }
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function init() {
    document.querySelectorAll('[data-gg-sticky-120]').forEach(bar => {
      if (bars.has(bar)) return;
      const submit = bar.querySelector('[data-sticky-submit]');
      const main = submit?.form?.querySelector('[data-buy]');
      if (!main) return;
      const sibling = bar.nextElementSibling;
      const spacer = sibling?.classList.contains('ggm-sticky-spacer') ? sibling : null;
      if (spacer) spacer.setAttribute('data-gg-sticky-space-120', '');
      const entry = { main, submit, spacer, visible: undefined };
      bars.set(bar, entry);
      if ('ResizeObserver' in window) {
        entry.resize = new ResizeObserver(schedule);
        entry.resize.observe(main);
        entry.resize.observe(bar);
      }
    });
    schedule();
  }
  const start = () => {
    init();
    const observer = new MutationObserver(changes => {
      if (changes.some(change => change.type === 'childList' &&
        [...change.addedNodes].some(node => node.nodeType === 1 &&
          (node.matches('[data-gg-sticky-120],ggm-product') || node.querySelector('[data-gg-sticky-120],ggm-product'))))) init();
      schedule();
    });
    observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'disabled']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', init);
  document.addEventListener('fullscreenchange', schedule);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', schedule);
})();


/* GG_STICKY_BUY_121_PREVIEW_OFFSET */
(() => {
  'use strict';
  if (window.ggStickyPreview121) return;
  window.ggStickyPreview121 = true;
  let toolbar, resize, attributes, frame = 0;
  const selector = '#PBarNextFrameWrapper';
  function update() {
    frame = 0;
    let offset = 0;
    if (toolbar?.isConnected) {
      const box = toolbar.getBoundingClientRect();
      const style = getComputedStyle(toolbar);
      if (box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < innerHeight &&
          style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
        // Measure the clipped wrapper, never the full-height iframe inside it.
        offset = Math.ceil(innerHeight - Math.max(0, box.top)) + 8;
      }
    }
    const value = offset + 'px';
    if (document.documentElement.style.getPropertyValue('--gg-sticky-preview-offset') !== value) {
      document.documentElement.style.setProperty('--gg-sticky-preview-offset', value);
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function watch() {
    const next = document.querySelector(selector);
    if (next !== toolbar) {
      resize?.disconnect();
      attributes?.disconnect();
      toolbar = next;
      if (toolbar) {
        if ('ResizeObserver' in window) {
          resize = new ResizeObserver(schedule);
          resize.observe(toolbar);
        }
        attributes = new MutationObserver(schedule);
        attributes.observe(toolbar, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'popover'] });
      }
    }
    schedule();
  }
  function start() {
    watch();
    new MutationObserver(records => {
      if (!toolbar?.isConnected || records.some(record => [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) watch();
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('toggle', event => { if (event.target === toolbar) schedule(); }, true);
  window.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', watch);
})();
